import { useState } from "react";
import { Check, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLanguage } from "../i18n";

export default function ShareButton({ url, title = "SIMAMMA", text = "", testid = "share-button", className = "" }) {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const full = url?.startsWith("http") ? url : `${window.location.origin}${url}`;
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url: full });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(full);
      setCopied(true);
      toast.success(t("share.copied"));
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt(title, full);
    }
  };

  return (
    <button data-testid={testid} onClick={share} aria-label={t("share.share")}
      className={`inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 font-mono-t text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500 hover:border-[#FF6B35] hover:text-[#FF6B35] transition-colors ${className}`}>
      {copied ? <Check className="w-3.5 h-3.5 text-emerald-500" /> : <Share2 className="w-3.5 h-3.5" />}
      {copied ? t("share.copied") : t("share.share")}
    </button>
  );
}
